document.addEventListener("DOMContentLoaded", function () {
  const stickyAtc = document.getElementById("StickyATC");
  const atcButton = document.querySelector('.product-form__submit[name="add"]');
  const stickyButton = document.querySelector(".sticky-atc__button");

  
  if (!stickyAtc || !atcButton || !stickyButton) return;

  // --- Auto-select single size & sync sticky ATC ---
  const applySelectedVariantId = () => {
    const variantSelects = document.querySelector("variant-selects");
    if (!variantSelects) return false;

    const selectedVariantScript = variantSelects.querySelector("[data-selected-variant]");
    if (!selectedVariantScript?.textContent) return false;

    try {
      const variant = JSON.parse(selectedVariantScript.textContent);
      if (!variant?.id) return false;

      const formVariantInput = document.querySelector('product-form input[name="id"]');
      if (formVariantInput) {
        formVariantInput.value = variant.id;
        formVariantInput.disabled = false;
      }

      stickyButton.dataset.variantId = variant.id;
      return true;
    } catch (e) {
      return false;
    }
  };

  const syncSingleSizeSelection = (variantSelects = document.querySelector("variant-selects")) => {
    if (!variantSelects) return;

    const singleSizeFieldset = variantSelects.querySelector('[data-single-size="true"]');
    if (!singleSizeFieldset) return;

    const sizeInput =
      singleSizeFieldset.querySelector('input[type="radio"]:not(:disabled)') ||
      singleSizeFieldset.querySelector('input[type="radio"]');
    if (!sizeInput) return;

    sizeInput.checked = true;
    applySelectedVariantId();

    const sizeOption = stickyAtc.querySelector("#StickySizeOption");
    const sizeValueEl = sizeOption?.querySelector(".sticky-atc__option-value");
    if (!sizeOption || !sizeValueEl) return;

    sizeValueEl.textContent = sizeInput.value;
    sizeOption.classList.remove("hidden");
  };

  syncSingleSizeSelection();

  // --- show/hide sticky ATC ---
  const toggleStickyVisibility = (isIntersecting, rect) => {
    const isAboveViewport = rect
      ? rect.top < 0
      : window.scrollY > atcButton.offsetTop;

    if (!isIntersecting && isAboveViewport) {
      stickyAtc.classList.add("show");
    } else {
      stickyAtc.classList.remove("show");
    }
  };

  // Initial Check for Page Refresh
  setTimeout(() => {
    const initialRect = atcButton.getBoundingClientRect();
    const isInitialVisible =
      initialRect.top >= 0 && initialRect.bottom <= window.innerHeight;
    toggleStickyVisibility(isInitialVisible, initialRect);
  }, 100);

  // Continuous Observer for Scrolling
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        toggleStickyVisibility(entry.isIntersecting, entry.boundingClientRect);
      });
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -120px 0px",
    },
  );
  observer.observe(atcButton);

  // ---  Scroll Color Option Click ---
  try {
    const stickyColorOption = document.getElementById("StickyColorOption");
    const pdpColorSwatch = document.querySelector(".product-color-swatch");

    if (stickyColorOption && pdpColorSwatch) {
      stickyColorOption.addEventListener("click", function () {
        pdpColorSwatch.scrollIntoView({
          behavior: "smooth",
          block: "center" 
        });
      });
    }
  } catch (error) {
    console.warn("Sticky ATC color scroll failed to initialize:", error);
  }

  // --- Sticky Add to cart functionality -----
  const clearStickyVariantErrors = () => {
    const errorWrapper = stickyAtc.querySelector(".product-form__error-message-wrapper");
    const errorMessageEl = stickyAtc.querySelector(".product-form__error-message");
    if (errorWrapper) errorWrapper.setAttribute("hidden", "");
    if (errorMessageEl) errorMessageEl.textContent = "";

    const variantOptionWrapper = document.querySelector("variant-selects");
    variantOptionWrapper?.querySelector(".product-size__container")?.classList.remove("error");
    variantOptionWrapper?.querySelector(".product-length__container")?.classList.remove("error");

    const productForm = document.querySelector("product-form");
    productForm?.handleErrorMessage();
  };

  document.querySelector("variant-selects")?.addEventListener("change", clearStickyVariantErrors);

  const showStickyVariantError = (errorMessage, errorTypes = []) => {
    const errorWrapper = stickyAtc.querySelector(".product-form__error-message-wrapper");
    const errorMessageEl = stickyAtc.querySelector(".product-form__error-message");
    const variantOptionWrapper = document.querySelector("variant-selects");
    const sizeVariantOption = variantOptionWrapper?.querySelector(".product-size__container");
    const lengthVariantOption = variantOptionWrapper?.querySelector(".product-length__container");
    const productForm = document.querySelector("product-form");
    const isSingleSize = !!variantOptionWrapper?.querySelector('[data-single-size="true"]');
    let normalizedErrorTypes = Array.isArray(errorTypes) ? [...errorTypes] : [];

    // Single size is hidden/auto-selected — never treat as a size selection error
    if (isSingleSize) {
      normalizedErrorTypes = normalizedErrorTypes.filter((type) => type !== "sizeSelectionError");
      if (!normalizedErrorTypes.length && errorMessage === window.variantStrings?.sizeSelectionError) {
        return;
      }
    }

    clearStickyVariantErrors();

    sizeVariantOption?.classList.toggle("error", normalizedErrorTypes.includes("sizeSelectionError"));
    lengthVariantOption?.classList.toggle("error", normalizedErrorTypes.includes("lengthSelectionError"));

    if (errorMessageEl && errorWrapper) {
      errorMessageEl.textContent = errorMessage;
      errorWrapper.removeAttribute("hidden");
    }

    // Keep main product-form error message in sync with sticky ATC
    productForm?.handleErrorMessage(errorMessage, normalizedErrorTypes);

    if (normalizedErrorTypes.includes("sizeSelectionError") || normalizedErrorTypes.includes("lengthSelectionError")) {
      variantOptionWrapper?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  const validateStickyVariantSelections = () => {
    const variantSelects = document.querySelector("variant-selects");
    if (!variantSelects) return true;

    syncSingleSizeSelection(variantSelects);

    const optionFieldsets = variantSelects.querySelectorAll("fieldset.product-form__input--pill");
    if (!optionFieldsets.length) return true;

    const missingErrorTypes = [];

    optionFieldsets.forEach((fieldset) => {
      // Single size is auto-selected and hidden — never block ATC for it
      if (fieldset.dataset.singleSize === "true") return;

      const selectableInputs = fieldset.querySelectorAll('input[type="radio"]:not(:disabled)');
      if (!selectableInputs.length) return;
      if (fieldset.querySelector('input[type="radio"]:checked')) return;

      if (fieldset.classList.contains("product-length__container")) {
        missingErrorTypes.push("lengthSelectionError");
      } else {
        missingErrorTypes.push("sizeSelectionError");
      }
    });

    if (!missingErrorTypes.length) return true;

    const isSingleSize = !!variantSelects.querySelector('[data-single-size="true"]');
    const filteredErrorTypes = isSingleSize
      ? missingErrorTypes.filter((type) => type !== "sizeSelectionError")
      : missingErrorTypes;

    if (!filteredErrorTypes.length) return true;

    const hasSizeError = filteredErrorTypes.includes("sizeSelectionError");
    const hasLengthError = filteredErrorTypes.includes("lengthSelectionError");
    let errorMessage = window.variantStrings?.sizeSelectionError;

    if (hasSizeError && hasLengthError) {
      errorMessage = [window.variantStrings?.sizeSelectionError, window.variantStrings?.lengthSelectionError]
        .filter(Boolean)
        .join(" ");
    } else if (hasLengthError) {
      errorMessage = window.variantStrings?.lengthSelectionError;
    }

    showStickyVariantError(errorMessage, filteredErrorTypes);
    return false;
  };

  stickyButton.addEventListener("click", async function (e) {
    e.preventDefault();

    if (stickyButton.classList.contains("loading") || stickyButton.hasAttribute("disabled")) {
      return;
    }

    clearStickyVariantErrors();

    if (!validateStickyVariantSelections()) return;

    // Prefer live form variant id, then sticky dataset, then selected-variant JSON
    const formVariantId = document.querySelector('product-form input[name="id"]')?.value;
    let variantId = formVariantId || stickyButton.dataset.variantId;

    if (!variantId) {
      applySelectedVariantId();
      variantId = stickyButton.dataset.variantId;

      if (!variantId) {
        showStickyVariantError(
          window.variantStrings?.sizeSelectionError || "Cannot find variant",
          ["sizeSelectionError"]
        );
        return;
      }
    }

    stickyButton.dataset.variantId = variantId;
    const loaderEl = stickyButton.querySelector(".product-card__spinner");
    const textEl = stickyButton.querySelector("span");

    // Show loader
    stickyButton.classList.add("loading");
    stickyButton.setAttribute("aria-disabled", "true");
    if (loaderEl) loaderEl.classList.remove("hidden");

    // Capture and set "Adding" state
    let originalText = "";
    if (textEl) {
      originalText = textEl.textContent;
      textEl.textContent = window.variantStrings?.adding || "ADDING";
    }

    try {
      const config = { ...fetchConfig('javascript') };
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('form_type', 'product');
      formData.append('sections', "cart-drawer,cart-icon-bubble");
      config.body = formData;

      const response = await fetch(`${routes.cart_add_url}`, config);
      const data = await response.json();

      if (!response.ok || data.status || data.description) {
        const errorMessage = data.description || data.message || "Something went wrong!";
        throw new Error(errorMessage);
      }

      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
        }
        cartDrawer.renderContents(data);
        cartDrawer.open();
      }

    } catch (error) {
      console.error("Error adding to cart:", error);

      const errorWrapper = stickyAtc.querySelector(".product-form__error-message-wrapper");
      const errorMessageEl = stickyAtc.querySelector(".product-form__error-message");

      if (errorMessageEl && errorWrapper) {
        errorMessageEl.textContent = error.message;
        errorWrapper.removeAttribute("hidden");
      }
    } finally {
      if (loaderEl) {
        loaderEl.classList.add("hidden");
      }
      // Restore original button text
      if (textEl && originalText) {
        textEl.textContent = originalText;
      }

      stickyButton.classList.remove("loading");
      stickyButton.removeAttribute("aria-disabled");
    }
  });
});